import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import ProductsPage from "../pages/products/page";
import CategoriesPage from "../pages/categories/page";
import ShopPage from "../pages/shop/page";
import BrandsPage from "../pages/brands/page";
import ProductDetailPage from "../pages/product/page";
import CategoryPage from "../pages/category/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";
import BlogPost from "../pages/blog/post";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import TermsOfService from "../pages/legal/TermsOfService";
import CookiePolicy from "../pages/legal/CookiePolicy";
import RefundPolicy from "../pages/legal/RefundPolicy";
import ShippingPolicy from "../pages/legal/ShippingPolicy";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/product/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/category/:id",
    element: <CategoryPage />,
  },
  {
    path: "/brands",
    element: <BrandsPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPost />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/cookies",
    element: <CookiePolicy />,
  },
  {
    path: "/refund",
    element: <RefundPolicy />,
  },
  {
    path: "/shipping",
    element: <ShippingPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
